'use strict';

// prevent button default
let allButtons = document.querySelectorAll('button');
buttonDefault();

function buttonDefault() {
  for (let i = 0; i < allButtons.length; i++) {
    allButtons[i].addEventListener('click', function (e) {
      e.preventDefault ? e.preventDefault() : (e.returnValue = false);
    });
  }
}

// add/remove children
let c = 0;
// const childCounter = document.querySelector('.children-counter__number');
// const childCounterText = document.querySelector('.children-counter__text');
const childIncrease = document.querySelector('.children-counter__add-child');
const childParent = document.querySelector('.loan-calculator-table__cell-children');
let children;
let childInput = document.querySelectorAll('.children-propagation__question-input');

// add child
childIncrease.addEventListener('click', function () {
  addChild();
});

function addChild() {
  ++c;
  const childDiv = document.createElement('div');
  childDiv.classList.add('loan-calculator-table__cell-children-propagation');
  childDiv.innerHTML = `<div class="children-propagation__title-mobile">Child <span class="children-propagation__title-number">${c}:</span></div>
		<div class="children-propagation__question">
			<span class="children-propagation__title">Child <span class="children-propagation__title-number">${c}:</span></span>
			<div class="child-propagation__question-container">
				<label for="child${c}-question1" class="children-propagation__question-label question-label1">Cost of tuition per year</label>
				<span class="children-propagation__question-input-container">
					<span class="loan-calculator-table__cell-dollar"></span>
					<input type="text" class="children-propagation__question-input question-input1" id="child${c}-question1" name="child${c}-question1">
				</span>
			</div>
			<div class="child-propagation__question-container">
				<label for="child${c}-question2" class="children-propagation__question-label question-label2">Number of years in school</label>
				<span class="children-propagation__question-input-container">
					<input type="text" class="children-propagation__question-input question-input2" id="child${c}-question2" name="child${c}-question2">
				</span>
			</div>
			<button class="children-propagation__add" aria-label="add another child">
				<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" class="children-propagation__add-icon" viewBox="0 0 64 64" width="30px" height="32px">
				<g id="surface628261">
					<path d="M 32 3.027344 C 24.574219 3.027344 17.148438 5.851562 11.5 11.5 C 0.199219 22.800781 0.199219 41.199219 11.5 52.5 C 17.148438 58.148438 24.601562 61 32 61 C 39.398438 61 46.851562 58.148438 52.5 52.5 C 63.800781 41.199219 63.800781 22.800781 52.5 11.5 C 46.851562 5.851562 39.425781 3.027344 32 3.027344 Z M 32 6 C 38.648438 6 45.300781 8.550781 50.398438 13.601562 C 60.5 23.75 60.5 40.25 50.398438 50.402344 C 40.25 60.550781 23.75 60.550781 13.652344 50.402344 C 3.5 40.25 3.5 23.75 13.601562 13.601562 C 18.699219 8.550781 25.351562 6 32 6 Z M 32 21 C 31.148438 21 30.5 21.648438 30.5 22.5 L 30.5 30.5 L 22.5 30.5 C 21.648438 30.5 21 31.148438 21 32 C 21 32.851562 21.648438 33.5 22.5 33.5 L 30.5 33.5 L 30.5 41.5 C 30.5 42.351562 31.148438 43 32 43 C 32.851562 43 33.5 42.351562 33.5 41.5 L 33.5 33.5 L 41.5 33.5 C 42.351562 33.5 43 32.851562 43 32 C 43 31.148438 42.351562 30.5 41.5 30.5 L 33.5 30.5 L 33.5 22.5 C 33.5 21.648438 32.851562 21 32 21 Z M 32 21 "/>
				</g>
				</svg>
			</button>
			<button class="children-propagation__delete" aria-label="remove child">
				<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" class="children-propagation__delete-icon" viewBox="0 0 24 24" width="24px" height="24px">
				<g id="surface75337628">
				<path d="M 12 2 C 6.46875 2 2 6.46875 2 12 C 2 17.53125 6.46875 22 12 22 C 17.53125 22 22 17.53125 22 12 C 22 6.46875 17.53125 2 12 2 Z M 17 15.589844 L 15.589844 17 L 12 13.410156 L 8.410156 17 L 7 15.589844 L 10.589844 12 L 7 8.410156 L 8.410156 7 L 12 10.589844 L 15.589844 7 L 17 8.410156 L 13.410156 12 Z M 17 15.589844 "/>
				</g>
				</svg>
			</button>
		</div>`;

  childParent.appendChild(childDiv);
  childInput = document.querySelectorAll('.children-propagation__question-input');
  childInputsLimit();
  children = document.querySelectorAll('.loan-calculator-table__cell-children-propagation');
  allButtons = document.querySelectorAll('button');
  buttonDefault();
}

// remove child
document.addEventListener('click', function (e) {
  const element = e.target;
  if (element.classList.contains('children-propagation__delete')) {
    --c;
    let child = element.parentElement.parentElement;
    child.parentElement.removeChild(child);
  } else if (element.classList.contains('children-propagation__add')) {
    addChild();
  }

  children = document.querySelectorAll('.loan-calculator-table__cell-children-propagation');
  for (let i = 0; i < children.length; i++) {
    let index = parseInt(i + 1);
    const childNum = children[i].querySelector('.children-propagation__title');
    const childNumMobile = children[i].querySelector('.children-propagation__title-mobile');
    let question1 = children[i].querySelector('.question-input1');
    let question2 = children[i].querySelector('.question-input2');
    let questionlabel1 = children[i].querySelector('.question-label1');
    let questionlabel2 = children[i].querySelector('.question-label2');
    question1.id = `child${index}-question1`;
    question2.id = `child${index}-question2`;
    question1.setAttribute('name', `child${index}-question1`);
    question2.setAttribute('name', `child${index}-question2`);
    questionlabel1.setAttribute('for', `child${index}-question1`);
    questionlabel2.setAttribute('for', `child${index}-question2`);
    childNumMobile.innerText = `Child ${index}:`;
    childNum.innerText = `Child ${index}:`;
  }
});

const calculatorSubmit = document.querySelector('.loan-calculator-table__submit');
let q6 = 0;
let totalIncome = 0;
let totalCurrentProtection = 0;
let lifeInsuranceNeeded = 0;
let dropdown = document.getElementById('question1');
// let childrenContainer = document.querySelector('.loan-calculator-table__cell-children');
children = document.querySelectorAll('.loan-calculator-table__cell-children-propagation');
let result = document.querySelector('.loan-calculator-result');
let submitBtn = document.querySelector('.loan-calculator-table__submit');
let ctaBtn = document.querySelector('.loan-calculator-table__cta');
let input = document.querySelectorAll('.loan-calculator-table__cell-input');

calculatorSubmit.addEventListener('click', function () {
  let q1 = parseFloat(dropdown.value);
  let q2 = parseFloat(document.getElementById('question2').value.replace(/,/g, ''));
  let q1q2product = parseFloat(q2 * q1);
  let q3 = parseFloat(document.getElementById('question3').value.replace(/,/g, ''));
  let q4 = parseFloat(document.getElementById('question4').value.replace(/,/g, ''));
  let q5 = parseFloat(document.getElementById('question5').value.replace(/,/g, ''));
  let q7 = parseFloat(document.getElementById('question7').value.replace(/,/g, ''));
  let q8 = parseFloat(document.getElementById('question8').value.replace(/,/g, ''));
  let q9 = parseFloat(document.getElementById('question9').value.replace(/,/g, ''));
  if (!q9) {
    q9 = 0;
  }

  var nanArray = [q1, q2, q3, q4, q5, q6, q7, q8];

  findNan(nanArray);
  function findNan(arr) {
    var errorArray = [];
    for (let i = 0; i < arr.length; i++) {
      if (Number.isNaN(arr[i]) || q1 == 0) {
        let index = parseInt(i + 1);
        let questionNum = document.getElementById(`question${index}`);
        questionNum.setAttribute('aria-invalid', 'true');
        questionNum.nextElementSibling.classList.remove('loan-calculator-table__error--hidden');
        errorArray.push(questionNum);
      }
    }
    if (errorArray.length > 1) {
      alert(`Form submission failed. There are ${errorArray.length} errors. Please review the form and resubmit.`);
      errorArray[0].focus();
    } else if (errorArray.length == 1) {
      alert('Form submission failed. There is 1 error. Please review the form and resubmit.');
      errorArray[0].focus();
    }
  }

  for (let i = 0; i < childInput.length; i++) {
    if (childInput[i].value.length === 0) {
      childInput[i].value = 0;
      childInput[i].innerHtml = '';
    }
  }

  calculate6(children);

  calculateTotalIncome(q1q2product, q3, q4, q5, q6);

  calculateTotalCurrentProtection(q7, q8);

  calculateLifeInsuranceNeeded(totalIncome, totalCurrentProtection, q9);

  if (lifeInsuranceNeeded == lifeInsuranceNeeded) {
    result.innerText = `Your estimated life insurance need is: $${numberWithCommasDecimal(lifeInsuranceNeeded)}`;
    submitBtn.classList.add('loan-calculator-table__submit--hidden');
    ctaBtn.classList.remove('loan-calculator-table__cta--hidden');
  } else {
    result.innerText = `There was a problem calculating your insurance needs. Please refresh and try again.`;
  }

  if (lifeInsuranceNeeded <= 100000) {
    result.innerText = 'You are not eligible for life insurance through LGA at this time.';
    ctaBtn.classList.add('loan-calculator-table__cta--hidden');
    result.style.fontWeight = '700';
  }
});

function calculate6(children) {
  for (let i = 0; i < children.length; i++) {
    let q1value = parseFloat(children[i].querySelector('.question-input1').value.replace(/,/g, ''));
    let q2value = parseFloat(children[i].querySelector('.question-input2').value.replace(/,/g, ''));
    let product = parseFloat(q1value) * parseFloat(q2value);
    q6 += product;
  }
}

function calculateTotalIncome(num1, num2, num3, num4, num5) {
  totalIncome = num1 + num2 + num3 + num4 + num5;
  return parseFloat(totalIncome);
}

function calculateTotalCurrentProtection(num1, num2) {
  totalCurrentProtection = num1 + num2;
  return parseFloat(totalCurrentProtection);
}

function calculateLifeInsuranceNeeded(num1, num2, num3) {
  lifeInsuranceNeeded = num1 - num2 + num3;
  return parseFloat(lifeInsuranceNeeded);
}

// main inputs
for (let i = 0; i < input.length; i++) {
  if (!input[i].querySelector('.loan-calculator-table__error--hidden')) {
    input[i].addEventListener('focus', function () {
      input[i].nextElementSibling.classList.add('loan-calculator-table__error--hidden');
    });
  }

  // add commas
  input[i].addEventListener('keyup', function (e) {
    // skip for arrow keys
    if (e.which >= 37 && e.which <= 40) {
      e.preventDefault();
    }
    var num = this.value.replace(/,/gi, '');
    var num2 = num.split(/(?=(?:\d{3})+$)/).join(',');
    this.value = num2;
  });

  // limit inputs to numbers only (no decimal)
  function numbersOnly(event) {
    return event.charCode >= 48 && event.charCode <= 57;
  }
  input[i].onkeypress = numbersOnly;
}

// child inputs
function childInputsLimit() {
  for (let i = 0; i < childInput.length; i++) {
    // add commas
    childInput[i].addEventListener('keyup', function (e) {
      // skip for arrow keys
      if (e.which >= 37 && e.which <= 40) {
        e.preventDefault();
      }
      var num = this.value.replace(/,/gi, '');
      var num2 = num.split(/(?=(?:\d{3})+$)/).join(',');
      this.value = num2;
    });

    // limit childInputs to numbers only (no decimal)
    function numbersOnly(event) {
      return event.charCode >= 48 && event.charCode <= 57;
    }
    childInput[i].onkeypress = numbersOnly;
  }
}

//remove error message for question1 dropdown
const question1 = document.getElementById('question1');
question1.addEventListener('change', function () {
  question1.nextElementSibling.innerText = '';
});

// add commas and decimals to final total
function numberWithCommasDecimal(x) {
  return x.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',');
}

const tooltip = document.querySelectorAll('.loan-calculator-table__cell-tooltip');

for (let i = 0; i < tooltip.length; i++) {
  tooltip[i].addEventListener('click', function () {
    if (!tooltip[i].nextElementSibling.classList.contains('active')) {
      tooltip[i].nextElementSibling.classList.add('active');
    } else {
      tooltip[i].nextElementSibling.classList.remove('active');
    }
  });
}
